module.exports = __webpack_public_path__ + "img/symbol_8.a7883bba.png";